import { Ability } from '@casl/ability';
import { Actions, Subjects } from '@dispatch/shared/types';

export interface NavRoute {
  title: string;
  route: string;
  permissions?: (permissions?: Ability<[Actions, Subjects]>) => boolean;
  children?: NavRoute[];
}

export const routes: NavRoute[] = [
  {
    title: 'Complex Loss',
    route: '/complex-loss',
    permissions: (permissions) => !!permissions?.can('access', 'complex-loss'),
  },
  {
    title: 'Tasks',
    route: '/tasks',
  },
  {
    title: 'Scheduler',
    route: '/scheduler',
  },
  {
    title: 'Resources',
    route: '/resources',
    permissions: (permissions) => !!permissions?.can('upsert', 'resource'),
  },
  {
    title: 'Capacity',
    permissions: (permissions) =>
      !!permissions?.can('access', 'capacity-dashboard'),
    route: '/capacity-dashboard',
  },
  {
    title: 'Reports',
    permissions: (permissions) => !!permissions?.can('create', 'reports'),
    route: '/reports',
  },
  {
    title: 'Administration',
    permissions: (permissions) =>
      !!permissions?.can('put', 'users') ||
      !!permissions?.can('upsert', 'task-group') ||
      !!permissions?.can('set', 'task-template') ||
      !!permissions?.can('put', 'roles') ||
      !!permissions?.can('set', 'regions'),
    route: '/admin',
    children: [
      {
        title: 'Users',
        permissions: (permissions) => !!permissions?.can('put', 'users'),
        route: '/users',
      },
      {
        title: 'Task Groups',
        permissions: (permissions) =>
          !!permissions?.can('upsert', 'task-group'),
        route: '/task-groups',
      },
      {
        title: 'Task Templates',
        permissions: (permissions) =>
          !!permissions?.can('set', 'task-template'),
        route: '/task-templates',
      },
      {
        title: 'Regions',
        permissions: (permissions) => !!permissions?.can('set', 'regions'),
        route: '/regions',
      },
      {
        title: 'Roles',
        permissions: (permissions) => !!permissions?.can('put', 'roles'),
        route: '/roles',
      },
      {
        title: 'Company',
        permissions: (permissions) =>
          !!permissions?.can('edit', 'company-page'),
        route: '/company-admin',
      },
    ],
  },
];
